export default __webpack_public_path__ + "static/media/ocean_stick.6f942930.png";